import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { BackendResponse, Staff, entityName } from '@qtek/shared/models';
import { getGMTOffset } from '@qtek/shared/utils';
import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class StaffService extends HttpEntityManager<Staff, Staff> {
  protected http = inject(HttpClient);

  entityName: entityName = 'usr';

  constructor() {
    super(true);
  }

  getStaff(id?: string | number, query?: any) {
    return super.getAll(id, query);
  }

  createEmployee(employee: Staff) {
    return super.post(employee, undefined, {
      gmtOffset: getGMTOffset(),
      tzGuess: btoa(Intl.DateTimeFormat().resolvedOptions().timeZone),
      _snd: 'email',
    });
  }

  deleteStaffInfo(relId: string) {
    return super.delete(btoa(relId), {
      tp: 'val',
    });
  }

  deleteStaff(id: string) {
    return super.delete(btoa(id), {
      tp: 'force',
    });
  }

  updateStaff(payload: Staff, usrId: string) {
    return super.put(payload, btoa(usrId));
  }

  updateStaffPhone(payload: {
    userId: string;
    phoneNumber: string;
    car?: string;
    tp: number;
  }) {
    return this.http.put<BackendResponse<string>>(
      '/api/v1/service/update-phone-number',
      payload,
      this.baseRequestOptions
    );
  }

  sendInvitation(prsId: string, query: any) {
    const key = '_snd';
    const keyLanguage = 'lng';
    const value = Object.keys(query.sendingMethod)
      .filter(k => query.sendingMethod[k])
      .join('.');

    let params = new HttpParams().set(key, value);

    if (query.language) {
      params = params.append(keyLanguage, query.language);
    }

    return this.http.post<BackendResponse>(
      `/api/v1/service/snd/usr/${prsId}`,
      undefined,
      {
        ...this.baseRequestOptions,
        params,
      }
    );
  }
}
